export default "__VITE_PUBLIC_ASSET__152628e2__"